import React, { Fragment } from 'react';
import Link from 'gatsby-link';
import css from 'emotion';
import styled from 'react-emotion';
import { Transition } from 'react-transition-group';
import tinycolor from 'tinycolor2';

const duration = 200;

const transitionStyles = {
  entering: { height: 210, overflow: 'hidden' },
  entered: { height: 210, overflow: 'visible' },
  exiting: { height: 0, overflow: 'hidden' },
  exited: { height: 0, overflow: 'hidden' },
};

const MobileMenuBody = styled.div`
  background: ${props => props.theme.white};
  color: ${props => props.theme.textColor};
  position: absolute;
  padding-top: ${props => props.visible ? '20px' : '0'}; 
  top: 115px;
  left: 0;
  width: 100vw;
  max-width: 100%;
  z-index: 1002;
  transition: height ${duration}ms ease-in-out;
  height: 0;
  overflow: hidden;

  text-align: center;

  & p {
    margin-bottom: 10px;
    font-size: 14px;
    text-transform: uppercase;
    line-height: 1.25;
  }

  & ul {
    list-style-type: none;
    list-style-image: none;
    margin-bottom: 0.5em;
    margin-left: 0;
    margin-top &:last-child {
      margin-bottom: 1em;
    }

    & li {
      margin-bottom: 1.25rem;
    }
  }

  & a {
    color: ${props => props.theme.textColor};
    text-align: center;
    font-size: 28px;
    font-family: ${props => props.theme.serifFont};
    text-decoration: none;

    @media (min-width: 768px) {
        font-size: 35px;
    }

    &:hover {
      color: ${props => props.theme.secondary};
    }
  }
`;

const MenuBody = styled.div`

    & ul {
      margin-left: 0;
      margin-bottom: 0;
      display: flex;
      flex-direction: row;
      list-style-type: none;
      list-style-image: none;

      & li {
        margin-right: 32px;
        display: flex;
        align-items: center;
        margin-bottom: 0;

        &:last-child {
          margin-right: 0;
        }

        & a {
          color: ${props => props.theme.textColor};
          font-size: 16px;
          line-height: 20px;
          text-transform: uppercase;
          font-family: ${props => props.theme.serifFont};
          text-decoration: none;

          &:hover {
            color: ${props => props.theme.primaryHighlight};
          }
        }
      }
    }
`;

const Menu = ({ mobile, visible, children }) => {
  return (
    <Fragment>
      {mobile ? (
        <Transition in={visible} timeout={duration}>
          {state => {
            return (
              <MobileMenuBody
                style={{ ...transitionStyles[state] }}
                visible={visible}
              >
                {children}
              </MobileMenuBody>
            );
          }}
        </Transition>
      ) : (
        <MenuBody>{children}</MenuBody>
      )}
    </Fragment>
  );
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Common/Menu/index.js